angular.module('configModule')

.provider('appConfig', function ()
{
    var config = {};

    this.setConfig = function (key, value)
    {
        config[key] = value;
    };

    this.getConfig = function (key)
    {
        return config[key];
    };

    this.$get = function ()
    {
        return config;
    };
});
